import React from 'react';
import Image from 'next/image';
import Section from './Section';
import { EDUCATION_EN } from './index';
import AdviceAvatar from '@/assets/resume-advice/advice-avatar.png';

const EducationAdvice = () => {
  const [selectedTitle, setSelectedTitle] = React.useState('');

  return (
    <ul className="m-0 list-none">
      <Section
        title="怎样写出令人印象深刻的校园经历？"
        adviceIndex={1}
        selectedTitle={selectedTitle}
        setSelectedTitle={setSelectedTitle}
        link="https://www.tanzhi.cn/articles/resume-advice-education-experience-5/"
        sectionGroup={EDUCATION_EN}
        isRecommend={true}
        defaultChecked={true}
      >
        <p className="mb-3">方法：</p>
        <div className="bg-green-50 px-3 py-4 rounded-lg flex mb-2">
          <Image
            className="shrink-0"
            src={AdviceAvatar}
            alt=""
            style={{ width: 24, height: 24 }}
          />
          <span className="text-green-700 font-semibold ml-2">
            以描述一个项目的方式来描述自己在校内的经历
          </span>
          <span className="ml-auto shrink-0 self-center">👍 12</span>
        </div>
        <p className="mb-8 leading-6.5 text-green-900/70">
          它的作用就是让缺少实习经历或者是正式工作经历的职场新人，有机会的来完整呈现自己的能力。作为一个职场新人，当你已经有目标的求职岗位以后，可以在校园经历中融入目标岗位的能力要求。
        </p>
        <ul className="!ml-5 list-disc leading-6.5 text-black/85 mb-8">
          <li className="mb-4">
            <strong>校园经历中应该包含：</strong>
            <ul className="!ml-5 list-disc">
              <li>
                <strong>项目总述，</strong>简要描述项目和你的核心职责。
              </li>
              <li>
                <strong>项目过程，</strong>具体描述项目的实施细节，包括：
                <ul className="!ml-5 list-disc">
                  <li>
                    核心步骤的详细描述，例如：“主要组织者，负责与多个学生社团和部门协调，确保节目编排和反馈意见”。
                  </li>
                  <li>步骤最多不要超过7个，可以尝试将核心步骤总结为3-5项。</li>
                </ul>
              </li>
              <li>
                <strong>项目成果</strong>
                ，描述项目的成果，注意区分个人成果和项目成果。
              </li>
              <li>
                <strong>项目回顾，</strong>总结你在这段经历中学到的内容，包括：
                <ul className="!ml-5 list-disc">
                  <li>
                    经历中的挑战，例如：“准备工作超过2个半月，期间需要兼顾学业和细节规划”。
                  </li>
                  <li>
                    对关键点的思考，例如：“对活动现场效果、宣传和后期剪辑有了更深入的思考”。
                  </li>
                  <li>
                    与用人单位讨论的期望，例如：“期待在这些话题上进行更多探讨”。
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
        <p className="mb-3">示例：</p>
        <div className="border border-[#219653] border-dashed p-4 rounded-lg mb-3 text-black/85 leading-6.5">
          <p className="mb-3">校园经历：大学新年音乐会组织策划</p>
          <ul className="!ml-5 list-disc leading-6.5 text-black/85">
            <li>
              项目总述：
              <ul className="!ml-5 list-disc">
                <li>
                  作为大学艺管委的演出部的核心成员，我参与组织策划了在中山公园音乐堂举办的2020年大学新年音乐会。
                </li>
              </ul>
            </li>
            <li>
              项目过程：
              <ul className="!ml-5 list-disc">
                <li>
                  与演出部共同确定音乐会的准备工作开展方法，包括整体组织计划和关键时间点；
                </li>
                <li>
                  作为主要的组织者与多个学生社团和部门交流，确认各个社团的节目，并从整体节目编排上提供反馈意见；
                </li>
                <li>
                  与多个演出场地进行协商并最终确认以中山公园作为演出地点；
                </li>
                <li>
                  参与场地使用的细节沟通和注意事项并同步给其他部门，负责场地座位的具体编排；
                </li>
                <li>
                  参与新年音乐会的宣传工作，包括海报制作、校园广播和公众号活动文章编辑；
                </li>
                <li>
                  负责音乐会期间的摄影摄像，包括15个点位的协调，以及幕后场务；参与后期的摄影剪辑，以及呈现最终完整版音乐会现场记录视频。
                </li>
              </ul>
            </li>
            <li>
              项目成果：
              <ul className="!ml-5 list-disc">
                <li>音乐会总参与人数超过千人，获得年度演出荣誉。</li>
              </ul>
            </li>
            <li>
              项目回顾：
              <ul className="!ml-5 list-disc">
                <li>
                  我在这个校园经历中学习到了大型活动是如何组织开展的。此次新年音乐会的准备工作超过2个半月，在此期间有大量的细节需要思考、规划和沟通，同时要兼顾学业，期间的确有很多挑战，但最终取得了不错的成果。这类的活动也让我有机会对活动现场如何达到更好的效果、活动的宣传和后期剪辑上等话题产生了更多思考。期待和用人单位进行跟多的探讨。
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </Section>
      <Section
        title="一个完整的教育经历模块可以涵盖哪些内容？"
        adviceIndex={2}
        selectedTitle={selectedTitle}
        setSelectedTitle={setSelectedTitle}
        link="https://www.tanzhi.cn/articles/resume-advice-education-experience-1/"
        sectionGroup={EDUCATION_EN}
      >
        <p className="mb-3">一个完整的教育经历模块可以分为以下三部分：</p>
        <ul className="!ml-5 list-disc leading-6.5 text-black/85 mb-4">
          <li className="font-semibold">学历、专业、课程和成绩、研究课题；</li>
          <li>奖项和证书；</li>
          <li>校内职务和社团活动；</li>
        </ul>
        <p className="mb-3">小贴士：</p>
        <ul className="!ml-5 list-disc leading-6.5 text-black/85">
          <li>
            2和3可以视作是一个锦上添花的加分项，但若没有这部分内容也无需担心。
          </li>
          <li>
            用人单位看重的更多是你的职业定位、核心能力与职位的匹配程度，教育经历中的亮点很多就作为决定因素。
          </li>
          <li>
            作为职场新人（应届以及工作经验少于1年），因为简历上能够提供的信息缺少，可以较为完整的使用教育经历中的内容来为你塑造职业形象；对于工作经验较丰富的职场人士，则可以只提供最基本的内容，而以工作经历和项目经历来塑造你的职业形象。
          </li>
        </ul>
      </Section>
      <Section
        title="有丰富工作经验的求职者如何写教育经历？"
        adviceIndex={3}
        selectedTitle={selectedTitle}
        setSelectedTitle={setSelectedTitle}
        link="https://www.tanzhi.cn/articles/resume-advice-education-experience-3/"
        sectionGroup={EDUCATION_EN}
      >
        <ul className="!ml-5 list-disc leading-6.5 text-black/85">
          <li className="mb-4">
            <strong>教育经历的位置：</strong>
            <ul className="!ml-5 list-disc">
              <li>
                若你的工作经历更为亮眼（例如获得了显著的职业成就或担任了高管职位），应将教育经历放在工作经历之后，以突出工作经验。
              </li>
              <li>
                若你的教育背景更为亮眼（例如来自全球TOP200或985/211高校），可以将教育经历放在简历前面，确保用人单位首先注意到你的学术背景。
              </li>
            </ul>
          </li>
          <li className="mb-4">
            <strong>教育经历中的重点信息：</strong>
            <ul className="!ml-5 list-disc">
              <li>基本信息: 学校，学历，专业 就读时间。</li>
            </ul>
          </li>
          <li className="mb-4">
            <strong>可以选择列出的附加信息：</strong>
            <ul className="!ml-5 list-disc">
              <li>交换生经验：如果有国际交换生经历，可以列出。</li>
              <li>一等文凭：如有获得特别荣誉或一等文凭，可以提及。</li>
              <li>
                相关研究课题：若论文研究课题与当前职业领域相关，可以列出。
              </li>
            </ul>
          </li>
          <li className="mb-4">
            <strong>不需要包括的信息：</strong>
            <ul className="!ml-5 list-disc">
              <li>
                GPA、课程成绩、在校奖项、校内职务等，在职场经验丰富后一般不再需要重点展示。
              </li>
            </ul>
          </li>
          <li>
            <strong>专业论文和证书：</strong>
            <ul className="!ml-5 list-disc">
              <li>
                发表的论文、出版物、重要比赛奖项和专业证书等，建议单独放在相关模块中展示，不在教育经历中提及。
              </li>
            </ul>
          </li>
        </ul>
      </Section>
      <Section
        title="应届生和职场新人应该如何写教育经历？"
        adviceIndex={4}
        selectedTitle={selectedTitle}
        setSelectedTitle={setSelectedTitle}
        link="https://www.tanzhi.cn/articles/resume-advice-education-experience-2/"
        sectionGroup={EDUCATION_EN}
      >
        <div className="bg-green-50 px-3 py-4 rounded-lg flex mb-2">
          <Image
            className="shrink-0"
            src={AdviceAvatar}
            alt=""
            style={{ width: 24, height: 24 }}
          />
          <span className="text-green-700 font-semibold ml-2">
            两个策略：详尽描述教育经历，和增加校园经历模块
          </span>
          <span className="ml-auto shrink-0 self-center">👍 12</span>
        </div>
        <div className="mb-8 leading-6.5 text-green-900/70">
          <p>用人单位在评估职场新人时，主要关注以下三方面的特质：</p>
          <ul className="!ml-5 list-disc">
            <li>对岗位的热情</li>
            <li>学习能力和意愿</li>
            <li>基础素质</li>
          </ul>
        </div>
        <ul className="!ml-5 list-disc leading-6.5 text-black/85">
          <li className="mb-4">
            <strong>详尽描述教育经历：</strong>
            <ul className="!ml-5 list-disc">
              <li>
                <strong>学术成绩和研究课题，</strong>
                在描述学术成绩时，不仅仅列出分数，还可以简要说明你的研究课题的实际应用。例如：
                <ul className="!ml-5 list-disc">
                  <li>传统描述：“经济学研究论文，获得优异成绩。”</li>
                  <li>
                    优化描述：“撰写的‘市场波动对投资策略的影响’论文，获得优异成绩，论文建议被导师用于课程改进。”
                  </li>
                </ul>
              </li>
              <li>
                <strong>竞赛奖项和额外成就，</strong>
                在提到竞赛奖项时，增加一些过程描述，展示你为获奖所付出的努力。例如：
                <ul className="!ml-5 list-disc">
                  <li>传统描述：“数学竞赛第三名。”</li>
                  <li>
                    优化描述：“经过两个月的强化训练，获得数学竞赛第三名，展现出良好的学习能力和应对压力的能力。”
                  </li>
                </ul>
              </li>
              <li>
                <strong>校内职务和社团活动，</strong>
                在描述校内职务时，不仅要列出职位，还要强调你的具体贡献。例如：
                <ul className="!ml-5 list-disc">
                  <li>传统描述：“话剧社团成员。”</li>
                  <li>
                    优化描述：“话剧社团成员，负责剧本编撰和审定，成功排演话剧十场，展示了较强的组织和执行能力。”
                  </li>
                </ul>
              </li>
            </ul>
          </li>
          <li className="mb-4">
            <strong>增加校园经历模块</strong>
            <ul className="!ml-5 list-disc">
              <li>
                如果你的教育经历中包含额外的亮点，如重要的项目、论文或职务，可以考虑在简历中添加一个专门的校园经历模块，以便更全面地展示你的能力。
              </li>
            </ul>
          </li>
          <li>
            <strong>注意事项：</strong>
            <ul className="!ml-5 list-disc">
              <li>
                <strong>避免夸大：</strong>
                作为职场新人，不要在简历中夸大能力，例如避免使用“我具备优秀的执行能力、组织能力”等泛泛的描述。用具体的例子来展示你的能力更加可信。
              </li>
              <li>
                <strong>保持简洁：</strong>
                在描述课程、奖项和证书时，只提供最具代表性和含金量高的信息，避免冗长无关的细节，保持简历的简洁明了。
              </li>
            </ul>
          </li>
        </ul>
      </Section>
      <Section
        title="什么情况下要写校园经历？"
        adviceIndex={5}
        selectedTitle={selectedTitle}
        setSelectedTitle={setSelectedTitle}
        link="https://www.tanzhi.cn/articles/resume-advice-education-experience-4/"
        sectionGroup={EDUCATION_EN}
      >
        <div className="mb-8 leading-6.5 text-green-900/70">
          <p>
            对于缺乏实习或正式工作经历的职场新人，校园经历可以帮助你展示在校期间所培养的能力：
          </p>
          <ul className="!ml-5 list-disc">
            <li>执行能力：完成任务并做到位的能力。</li>
            <li>组织协调能力：在团队中协作或牵头项目的能力。</li>
            <li>学习能力：在有效思考的基础上快速学习和适应新事物的能力。</li>
          </ul>
        </div>
        <ul className="!ml-5 list-disc leading-6.5 text-black/85">
          <li className="mb-4">
            <strong>没有任何实习经历或求职经历：</strong>
            强烈建议增加校园经历模块，以弥补缺乏工作经验的不足。
          </li>
          <li className="mb-4">
            <strong>实习经历很少或实习经历缺乏亮点：</strong>
            如果实习经历有限且不具备显著的成就，可以通过校园经历展示你的能力和潜力。
          </li>
          <li>
            <strong>已经具备亮眼的实习经历或正式工作经历：</strong>
            对于这些求职者，尤其是刚离校或工作经验少于一年，可以考虑不增加校园经历模块，而是着重于工作经历和项目成果。
          </li>
        </ul>
      </Section>
    </ul>
  );
};

export default EducationAdvice;
